import Image from 'next/image';
import { c } from '../../../utils/tailwind-merge';
import { Video } from '../../atoms/Video/Video';
import { RichText } from '../../molecules/RichText/RichText';
import { PublisherOverviewProps } from './PublisherOverview.types';

export const PublisherOverview = ({
  hasCookieConsent,
  imageUrl,
  videoUrl,
  description,
  title,
  className,
  onOpenCookieSettings,
}: PublisherOverviewProps) => {
  return (
    <div className={c('mb-2 space-y-8', className)}>
      {videoUrl ? (
        <div className="bg-gray-200 relative aspect-video overflow-hidden rounded-md">
          <Video
            cookieConsent={hasCookieConsent}
            embedUrl={videoUrl}
            onOpenCookieSettings={onOpenCookieSettings}
          />
        </div>
      ) : imageUrl ? (
        <div className="relative aspect-video">
          <Image
            fill
            src={imageUrl}
            alt={title || ''}
            className="rounded-md object-cover"
          />
        </div>
      ) : null}
      <RichText
        html={description}
        className="w-full
        [&_p:first-child]:mb-8 [&_p:first-child]:mt-9 md:[&_p:first-child]:mb-6 md:[&_p:first-child]:mt-8
        [&_p:last-child]:text-sm
        [&_p]:font-normal [&_p]:text-grey-700 [&_p_strong]:mb-[18px] [&_p_strong]:block
        [&_p_strong]:text-sm [&_p_strong]:text-black"
      />
    </div>
  );
};
